import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { RECORDING_STATUS, CALL_STATUS } from '../../Constants';
import { onFulfill } from '../../lib/redux/util';
import actionTypes from '../../lib/redux/action-types';
import { Button } from '../../components';

const Wrapper = styled.div`
  z-index: 1;
  position: fixed;
  bottom: 0px;
  left: 40px;
  background: #333;
  color: white;
  padding: 10px;
  border-radius: 5px;
  width: 300px;

  h3 {
    text-align: center;
  }

  h5 {
    background: #00acca;
    padding: 8px;
    font-size: 15px;
  }

  ul {
    margin: 0px;
    padding: 0px;
    list-style: none;
  }
`;
const Li = styled.li`
  cursor: pointer;
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  margin-left: ${props => (props.active ? 16 : 0)}px;
  opacity: ${props => (props.active ? 1 : 0.6)};

  ${props =>
    !props.active &&
    css`
      &:hover {
        text-decoration: underline;
      }
    `}
`;

const DevTwilioPanel = ({ call, dispatch }) => {
  const [minimised, setMinimised] = useState(true);

  const recordingStatus = status =>
    dispatch({
      type: onFulfill(actionTypes.GET_CALL),
      payload: {
        recordingStatus: status,
        callStatus: call.callStatus,
        taskCallId: call.callId
      }
    });

  const callStatus = status =>
    dispatch({
      type: onFulfill(actionTypes.GET_CALL),
      payload: {
        recordingStatus: call.recordingStatus,
        callStatus: status,
        taskCallId: call.callId
      }
    });

  if (minimised) {
    return (
      <Wrapper>
        <h3>Dev Twilio Panel</h3>
        <Button onClick={() => setMinimised(false)}>Open</Button>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Button onClick={() => setMinimised(true)}>Close</Button>
      <h3>Dev Twilio Panel</h3>

      <h5>Recording Status</h5>
      <ul>
        <Li onClick={() => recordingStatus(null)} active={call.recordingStatus === null}>
          null
        </Li>
        <Li
          onClick={() => recordingStatus(RECORDING_STATUS.INPROGRESS)}
          active={call.recordingStatus === RECORDING_STATUS.INPROGRESS}
        >
          In Progress
        </Li>
        <Li
          onClick={() => recordingStatus(RECORDING_STATUS.COMPLETED)}
          active={call.recordingStatus === RECORDING_STATUS.COMPLETED}
        >
          Completed
        </Li>
        <br />
        <Li
          onClick={() => recordingStatus(RECORDING_STATUS.ABSENT)}
          active={call.recordingStatus === RECORDING_STATUS.ABSENT}
        >
          Absent
        </Li>
        <Li
          onClick={() => recordingStatus(RECORDING_STATUS.DELETED)}
          active={call.recordingStatus === RECORDING_STATUS.DELETED}
        >
          Deleted
        </Li>
      </ul>
      <h5>Call Status</h5>
      <ul>
        <Li
          onClick={() => callStatus(CALL_STATUS.INITIATED.code)}
          active={call.callStatus === CALL_STATUS.INITIATED.code}
        >
          Initiated
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.RINGING.code)}
          active={call.callStatus === CALL_STATUS.RINGING.code}
        >
          Ringing
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.INPROGRESS.code)}
          active={call.callStatus === CALL_STATUS.INPROGRESS.code}
        >
          In Progress
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.COMPLETED.code)}
          active={call.callStatus === CALL_STATUS.COMPLETED.code}
        >
          Completed
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.BUSY.code)}
          active={call.callStatus === CALL_STATUS.BUSY.code}
        >
          Busy
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.FAILED.code)}
          active={call.callStatus === CALL_STATUS.FAILED.code}
        >
          Failed
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.NOANSWER.code)}
          active={call.callStatus === CALL_STATUS.NOANSWER.code}
        >
          No Answer
        </Li>
        <Li
          onClick={() => callStatus(CALL_STATUS.CANCELED.code)}
          active={call.callStatus === CALL_STATUS.CANCELED.code}
        >
          Cancelled
        </Li>
      </ul>
    </Wrapper>
  );
};

DevTwilioPanel.propTypes = {
  call: PropTypes.shape({
    callStatus: PropTypes.number,
    recordingStatus: PropTypes.number,
    callId: PropTypes.string
  }).isRequired,
  dispatch: PropTypes.func.isRequired
};

export default connect(state => ({
  call: state.call
}))(DevTwilioPanel);
